module.exports = __webpack_public_path__ + "static/arrow-dark-8b837055a422da02830f4353aa2d21bb.png";